import { lazy } from 'react';
import { useHistory, Switch, Route, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SubscriptionsList } from './SubscriptionsList';
import { Header } from '../../components/common/Header';
import { PayAuthorizations } from '../authorizations/PayAuthorizations';
import { PayAccessControl } from '../authorizations/PayAccessControl';
const ImportSubscriptionsScreen = lazy(
  () => import('./ImportSubscriptionsScreen')
);
const ImportVariableSubscriptionsScreen = lazy(
  () =>
    import('./ImportVariableSubscriptions/ImportVariableSubscriptionsScreen')
);
const NewSubscriptionScreen = lazy(() =>
  import('./NewSubscriptionScreen').then((m) => ({
    default: m.NewSubscriptionScreen,
  }))
);
const EditSubscriptionScreen = lazy(() =>
  import('./EditSubscriptionScreen').then((m) => ({
    default: m.EditSubscriptionScreen,
  }))
);
const SubscriptionDetailScreen = lazy(() =>
  import('./SubscriptionDetailScreen').then((m) => ({
    default: m.SubscriptionDetailScreen,
  }))
);
const DebtInvoiceScreen = lazy(() =>
  import('../debtInvoice/DebtInvoiceScreen').then((m) => ({
    default: m.DebtInvoiceScreen,
  }))
);

export function SubscriptionsScreen(): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  const onNewClick = () => {
    history.push('/subscriptions/new');
  };

  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PayAccessControl allowed={PayAuthorizations.viewSubscriptions}>
          <Header
            title={t('screens.subscriptions.title')}
            primaryButton={{
              text: t('screens.subscriptions.new_subscription'),
              onClick: onNewClick,
              allowedAuthorization: PayAuthorizations.createSubscription,
            }}
          />
          <SubscriptionsList />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/new`}>
        <PayAccessControl allowed={PayAuthorizations.createSubscription}>
          <NewSubscriptionScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/:subscription_id/edit`}>
        <PayAccessControl allowed={PayAuthorizations.manageSubscriptions}>
          <EditSubscriptionScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/:subscription_id/detail`}>
        <PayAccessControl allowed={PayAuthorizations.viewSubscriptions}>
          <SubscriptionDetailScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/:subscription_id/new-debt-invoice`}>
        <PayAccessControl allowed={PayAuthorizations.createInvoice}>
          <DebtInvoiceScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/import`}>
        <PayAccessControl allowed={PayAuthorizations.createBulkSubscriptions}>
          <ImportSubscriptionsScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/update-variable`}>
        <PayAccessControl allowed={PayAuthorizations.updateBulkSubscriptions}>
          <ImportVariableSubscriptionsScreen />
        </PayAccessControl>
      </Route>
    </Switch>
  );
}
